import Helping from './Helping';
import validator from 'validator';
import { MESSAGE } from '../config/index';
const { EMPTY, NUMERIC, GREAT, LESS, LIMIT_GREAT, LIMIT_LESS, DECIMAL, SELECT, IMAGE, DLC, PAK, URL, REQUIRE, VIDEO } = MESSAGE;

export const setErrorFields = (field, message) => {
    let errorObject = {
        [`${field}` === "" ? `error_message` : `error_${field}_message`]: message,
        [`${field}` === "" ? "" : `error_${field}`]: field,
        error_type: "danger"
    };
    return errorObject;
}

export const clearErrorFields = field => {
    let clearErrorObject = {
        [`error_${field}_message`]: "",
        [`error_${field}`]: "",
        error_message: "",
        error_type: ""
    };
    return clearErrorObject;
}

let updateCallback = (res) => {

}

export const validateCallback = (callback) => {

    updateCallback = callback;

}

export const validateField = async (type, field, value, fileType = "", limit = "", errorField = "", dependency = {}, valueCheck = false, fileFor) => {
    let errorMessageField = "",
        errorObject = {};
    errorField !== "" ? errorMessageField = errorField.replace(/_/g, ' ').replace(/./, errorField[0].toUpperCase()) : errorMessageField = field.replace(/_/g, ' ').replace(/./, field[0].toUpperCase());
    let stringCase = (type === "string" && limit !== "") ? /^([a-zA-Z0-9 _-]{1,})$/ : /^[ A-Za-z0-9_.-]*$/;
    // if (field.includes('key') || field.includes('content')) {
    //     stringCase = /^[\s a-zA-Z0-9!@/#;\$%\^\&><*\)\(+=,._-]*$/g;
    //     }
    let message = field.includes("id") ?
        `${errorMessageField} should not be empty.` : (!field.includes("id") && limit === "") ? `${errorMessageField} can only have ${type} type value.` :
            type.toLowerCase() === "numeric" ? `${errorMessageField} can only have ${type} type value where the ${value} can be up-to ${limit} digits.` :
                type.toLowerCase() === "string" && limit !== "" ? `${errorMessageField} should be greater than ${limit} characters.` :
                    `${errorMessageField} can only have ${type} type value where the ${value} should not be null.`;

    if (type.toLowerCase() === 'string') {
        if (value.length < 1) {
            if (limit !== "") return { ...setErrorFields(field, Helping.getMessageString(EMPTY, errorMessageField)) };
            return { ...clearErrorFields(field), ...errorObject };
        }
        else if (field.toLowerCase() === 'description' && value.length < Number(limit)) {
            return { ...setErrorFields(field, Helping.getMessageString(GREAT, errorMessageField, limit)) };
        }
        // else if (field.toLowerCase() === 'name' && value.length > Number(limit)) {
        //     return {...setErrorFields(field, Helping.getMessageString(LESS,errorMessageField,limit))};
        // }
    }

    if (type.toLowerCase() === 'url') {
        if (value.length < 1) {
            if (limit !== "") return { ...setErrorFields(field, Helping.getMessageString(EMPTY, errorMessageField)) };
            return { ...clearErrorFields(field), ...errorObject };
        }
        else if (value.length > 0 && !validator.isURL(value)) {
            return { ...setErrorFields(field, Helping.getMessageString(URL, errorMessageField)) };
        }
    }

    if (type.toLowerCase() === 'numeric') {
        if (value.length < 1) {
            if (limit !== "") return { ...setErrorFields(field, Helping.getMessageString(EMPTY, errorMessageField)) }
            return { ...clearErrorFields(field), ...errorObject };
        }
        if (!validator.isInt(value)) {
            return { ...setErrorFields(field, Helping.getMessageString(NUMERIC, errorMessageField)) };
        }

        if (valueCheck && !Helping.isEmpty(dependency)) {
            if (dependency.check.toLowerCase() === GREAT.toLowerCase() && Number(value) < Number(dependency.value)) {
                return { ...setErrorFields(field, Helping.getMessageString(LIMIT_GREAT, errorField, dependency.name)) };
            }
            if (dependency.check.toLowerCase() === LESS.toLowerCase() && Number(value) > Number(dependency.value)) {
                return { ...setErrorFields(field, Helping.getMessageString(LIMIT_LESS, errorField, dependency.name)) };
            }
        }
    }

    if (type.toLowerCase() === 'datetime') {
        if (value.length < 1) {
            if (limit !== "") return { ...setErrorFields(field, Helping.getMessageString(EMPTY, errorMessageField)) }
            return { ...clearErrorFields(field), ...errorObject };
        }

        if (valueCheck && !Helping.isEmpty(dependency)) {
            if (dependency.check === GREAT && Helping.convertTimeStampToUnixTimeStamp(value) < Helping.convertTimeStampToUnixTimeStamp(dependency.value)) {
                return { ...setErrorFields(field, Helping.getMessageString(LIMIT_GREAT, errorField, dependency.name)) };
            }
            if (dependency.check === LESS && Helping.convertTimeStampToUnixTimeStamp(value) > Helping.convertTimeStampToUnixTimeStamp(dependency.value)) {
                return { ...setErrorFields(field, Helping.getMessageString(LIMIT_LESS, errorField, dependency.name)) };
            }
        }
    }

    if (type.toLowerCase() === 'decimal') {
        if (value.length < 1) {
            if (limit !== "") return { ...setErrorFields(field, Helping.getMessageString(EMPTY, errorMessageField)) }
            return { ...clearErrorFields(field), ...errorObject };
        }

        if (!validator.isCurrency(value, {
            symbol: '$',
            require_symbol: false,
            allow_space_after_symbol: false,
            symbol_after_digits: false,
            allow_negatives: false,
            parens_for_negatives: false,
            negative_sign_before_digits: false,
            negative_sign_after_digits: false,
            allow_negative_sign_placeholder: false,
            thousands_separator: ',',
            decimal_separator: '.',
            allow_decimal: true,
            require_decimal: false,
            digits_after_decimal: [1, 2, 3, 4, 5, 6, 7, 8],
            allow_space_after_digits: false
        })) {
            return { ...setErrorFields(field, Helping.getMessageString(DECIMAL, errorMessageField, value)) };
        }

        if (valueCheck && !Helping.isEmpty(dependency)) {
            if (dependency.check.toLowerCase() === GREAT.toLowerCase() && value < dependency.value) {
                return { ...setErrorFields(field, Helping.getMessageString(LIMIT_GREAT, errorField, dependency.name)) };
            }
            if (dependency.check.toLowerCase() === LESS.toLowerCase() && value > dependency.value) {
                return { ...setErrorFields(field, Helping.getMessageString(LIMIT_LESS, errorField, dependency.name)) };
            }
        }
    }

    if (type.toLowerCase() === "file") {
        if (value.target.files[0] === undefined) return { ...setErrorFields(field, Helping.getMessageString(SELECT, "file")) }

        const file = value.target.files[0];
        let name = file.name,
            extension = name.replace(/^.*\./, "");

        if (dependency.ip_id !== undefined && dependency.ip_id === "") {
            if (dependency.ip_name && !dependency.ip_name.replace(/\s/g, '').includes('terraart') && dependency.categories.length < 1) {
                errorObject = { ...setErrorFields("", Helping.getMessageString(REQUIRE, "Category")) }
            }
            else if (dependency.ip_name && !dependency.ip_name.replace(/\s/g, '').includes('terraart') && dependency.categories.length > 0 && dependency.category_id === "") {
                errorObject = { ...setErrorFields("category_id", Helping.getMessageString(EMPTY, "Category")) }
            }
            return errorObject = { ...errorObject, ...setErrorFields("ip_id", Helping.getMessageString(EMPTY, "IP")) }
        }
        else if (dependency.ip_name && !dependency.ip_name.replace(/\s/g, '').includes('terraart') && dependency.categories.length < 1) {
            return errorObject = { ...setErrorFields("", Helping.getMessageString(REQUIRE, "Category")) }
        }
        else if (dependency.ip_name && !dependency.ip_name.replace(/\s/g, '').includes('terraart') && dependency.categories.length > 0 && dependency.category_id === "") {
            return errorObject = { ...setErrorFields("category_id", Helping.getMessageString(EMPTY, "Category")) }
        }

        errorObject = { ...errorObject, ...clearErrorFields("ip_id") }
        errorObject = { ...errorObject, ...clearErrorFields("category_id") }
        
        if (fileType.toLowerCase() === "image") {
            if ("jpg" !== extension && "png" !== extension && "jpeg" !== extension && "gif" !== extension && "svg" !== extension) {
                message = Helping.getMessageString(IMAGE, field);
                return {
                    ...setErrorFields(field, message)
                };
            } else {
                // let result = await Helping.toBase64(file);
                // return {
                //     [`${field}`]: name,
                //     [`${field}Converted`]: result,
                //     ...clearErrorFields(field)
                // };
                errorObject = { ...errorObject, ...await Helping.signFile(fileFor, file, field, updateCallback) };
            }
        }
        else if (fileType.toLowerCase() === "video") {
            if ("mp4" !== extension) {
                message = Helping.getMessageString(VIDEO, field);
                return {
                    ...setErrorFields(field, message)
                };
            } else {
                // let result = await Helping.toBase64(file);
                errorObject = { ...errorObject, ...await Helping.signFile(fileFor, file, field, updateCallback) };
                // if (!Helping.isEmpty(errorObject)) {
                //     console.log('empty error');
                //     return {
                //         [`${field}`]: name,
                //         ...errorObject
                //     }
                // }
                // console.log({errorObject});
                return {
                    [`${field}`]: name,
                    //     [`${field}Converted`]: result,
                    ...errorObject,
                    ...clearErrorFields(field)
                };
                // if (field === "androidUrl") {
                // }
            }
        } else {
            if (fileType.toLowerCase() === "dlc") {
                if (extension !== "dlc") {
                    message = Helping.getMessageString(DLC, field);
                    return { ...setErrorFields(field, message) };
                } else {
                    errorObject = { ...errorObject, ...await Helping.signFile(fileFor, file, field, updateCallback) };
                }
            } else {
                if (extension !== "pak") {
                    message = Helping.getMessageString(PAK, field);
                    return { ...setErrorFields(field, message) };
                } else {
                    errorObject = { ...errorObject, ...await Helping.signFile(fileFor, file, field, updateCallback) };
                }
            }

        }
    }
    return { ...clearErrorFields(field), ...errorObject };
};
